import { FC } from 'react'

import { Image, Text, View } from '@react-pdf/renderer'
import { PrintablePurchaseOrderHeaderFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type LogoProps = {
  logo: string | null
}

type Props = PrintablePurchaseOrderHeaderFragment & LogoProps

const Header: FC<Props> = ({ formattedPoNumber, date, deadline, logo }) => {
  const logoUrl = buildUrl(logo)

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
      {logo && <Image src={logoUrl} style={{ maxWidth: 104, height: 'auto', maxHeight: 52 }} />}
      <View style={{ width: 200 }}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text style={{ fontSize: 10 }}>
            {i18n.t('procurement.purchase_orders.pdf.po_number')}:
          </Text>
          <Text style={{ fontSize: 10 }}>{formattedPoNumber}</Text>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text style={{ fontSize: 10 }}>{i18n.t('procurement.purchase_orders.pdf.date')}:</Text>
          <Text style={{ fontSize: 10 }}>{dateBackendDateTimeToUI(date)}</Text>
        </View>
        {deadline && (
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={{ fontSize: 10 }}>
              {i18n.t('procurement.purchase_orders.pdf.dueDate')}:
            </Text>
            <Text style={{ fontSize: 10 }}>{dateBackendDateTimeToUI(deadline)}</Text>
          </View>
        )}
      </View>
    </View>
  )
}

export default Header
